import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { ScheduledDate } from '../../../lookups';
import { SelectItem } from '../../../shared';
import moment from 'moment';

@Component({
    selector: 'ef-send-journal-entry-filter',
    templateUrl: './send-journal-entry-filter.component.html',
    styleUrls: ['./send-journal-entry-filter.component.scss'],
    standalone: false
})
export class SendJournalEntryFilterComponent implements OnInit, OnDestroy {
    @Input() payPeriods: ScheduledDate[];
    @Input() payPeriodsSelectItems: SelectItem[];
    filterFormGroup: UntypedFormGroup;
    @Output() FilterChanged = new EventEmitter();
    private active = true;
    constructor() {
        this.filterFormGroup = new UntypedFormGroup({
            PayPeriodEndDate: new UntypedFormControl(),
            LaborAccrualDate: new UntypedFormControl(),
            LeaveAccrualDate: new UntypedFormControl()
        });
    }

    ngOnInit(): void {
        this.filterFormGroup.valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                this.FilterChanged.emit(value);
            });
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    PayPeriodEndDateChanged($event) {
        const payPeriodStartDate =
            this.payPeriods.find(x => x.ScheduledDateID === $event.value)
                ?.ScheduledStartDate ?? new Date();
        const ppe =
            this.payPeriods.find(x => x.ScheduledDateID === $event.value)
                ?.ScheduledEndDate ?? new Date();
        const monthEnd = moment(payPeriodStartDate).endOf('month').toDate();
        const lad = monthEnd < ppe ? monthEnd : ppe;
        const controls = this.filterFormGroup.controls;
        controls.LaborAccrualDate.setValue(lad);
        controls.LeaveAccrualDate.setValue(moment(lad).add(1, 'days').toDate());
    }
}
